var _rect, _circle, _ellipse, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFasterCheckout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 30.5,
    r: 27.5,
    fill: "#F3FAE6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 30,
    rx: 11.5,
    ry: 11,
    fill: "#FDE28B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6554 17C30.3157 17 24.3105 23.0052 24.3105 30.3448C24.3105 37.6845 30.3157 43.6897 37.6554 43.6897C44.995 43.6897 51.0002 37.6845 51.0002 30.3448C51.0002 23.0052 44.995 17 37.6554 17ZM37.6554 40.7241C31.9468 40.7241 27.2761 36.0534 27.2761 30.3448C27.2761 24.6362 31.9468 19.9655 37.6554 19.9655C43.364 19.9655 48.0347 24.6362 48.0347 30.3448C48.0347 36.0534 43.364 40.7241 37.6554 40.7241Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1379 29.7518V23.6725C39.1379 22.8569 38.4706 22.1897 37.6551 22.1897C36.8396 22.1897 36.1724 22.8569 36.1724 23.6725V30.3449C36.1724 30.7156 36.3206 31.0862 36.6172 31.3828L39.5827 34.3483C39.8793 34.6449 40.2499 34.7931 40.6206 34.7931C40.9913 34.7931 41.362 34.6449 41.6586 34.3483C42.2517 33.7552 42.2517 32.8656 41.6586 32.2725L39.1379 29.7518Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6034 22.1897H9.48276C8.66724 22.1897 8 22.8569 8 23.6725C8 24.488 8.66724 25.1552 9.48276 25.1552H20.6034C21.419 25.1552 22.0862 24.488 22.0862 23.6725C22.0862 22.8569 21.419 22.1897 20.6034 22.1897Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6033 28.8621H12.4481C11.6326 28.8621 10.9653 29.5293 10.9653 30.3448C10.9653 31.1603 11.6326 31.8276 12.4481 31.8276H20.6033C21.4188 31.8276 22.086 31.1603 22.086 30.3448C22.086 29.5293 21.4188 28.8621 20.6033 28.8621Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6034 35.5344H16.1551C15.3396 35.5344 14.6724 36.2017 14.6724 37.0172C14.6724 37.8327 15.3396 38.4999 16.1551 38.4999H20.6034C21.4189 38.4999 22.0862 37.8327 22.0862 37.0172C22.0862 36.2017 21.4189 35.5344 20.6034 35.5344Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasterCheckout);
export default __webpack_public_path__ + "static/media/Faster-checkout.3c0f452a1dcf632e4437b5fa18a7cc38.svg";
export { ForwardRef as ReactComponent };